import { apiFetch } from "./apiClient";

export async function getDeviceCleaningConfigs(rcDeviceId) {
  const res = await apiFetch(
    `/api/services/cleaning/list-cleaning-configs/${rcDeviceId}`,
  );

  if (res.status === 404) {
    return [];
  }

  if (!res.ok) {
    throw new Error("Failed to fetch device cleaning configs");
  }

  return res.json();
}

export async function getDeviceAvailableConfigs(rcDeviceId) {
  const res = await apiFetch(
    `/api/services/cleaning/available-config-names/${rcDeviceId}`,
  );

  if (res.status === 404) {
    return [];
  }

  if (!res.ok) {
    throw new Error("Failed to fetch device available cleaning configs");
  }

  return res.json();
}

export async function createOrUpdateCleaningConfigs(cleaningConfigData) {
  const res = await apiFetch(`/api/services/cleaning/set-cleaning-configs`, {
    method: "POST",
    body: JSON.stringify(cleaningConfigData),
  });
  if (!res.ok) {
    throw new Error("Failed to create or update cleaning configs");
  }
  const data = await res.json();
  return { success: true, data };
}

// Cleaning presets (migration 041): named option sets per device ("Quick", "Deep clean")
export async function getDevicePresets(rcDeviceId, { activeOnly = true } = {}) {
  const res = await apiFetch(
    `/api/services/cleaning/presets/${rcDeviceId}${activeOnly ? "" : "?activeOnly=false"}`,
  );
  if (res.status === 404) {
    return [];
  }
  if (!res.ok) {
    throw new Error("Failed to fetch cleaning presets");
  }
  return res.json();
}

// Options the robot accepts: { device, option_types: [{ option_key, value_type, ... }] }
export async function getDeviceOptionTypes(rcDeviceId) {
  const res = await apiFetch(
    `/api/services/cleaning/option-types/${rcDeviceId}`,
  );
  if (res.status === 404) {
    return { device: null, option_types: [] };
  }
  if (!res.ok) {
    throw new Error("Failed to fetch cleaning option types");
  }
  return res.json();
}

// Create (no pk_id) or update a preset; values replace the preset's values
export async function saveDevicePreset(rcDeviceId, preset) {
  const res = await apiFetch(`/api/services/cleaning/presets/${rcDeviceId}`, {
    method: "POST",
    body: JSON.stringify(preset),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "Failed to save cleaning preset");
  }
  return data;
}

export async function deleteDevicePreset(rcDeviceId, presetPkId) {
  const res = await apiFetch(
    `/api/services/cleaning/presets/${rcDeviceId}/${presetPkId}`,
    { method: "DELETE" },
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "Failed to delete cleaning preset");
  }
  return data;
}

// Control access (migration 043): control users at the device's location and
// whether each one sees this device on the device controls page.
// -> { device, location, control_users: [{ user_pk_id, username, email, active, enabled, enabled_device_count }] }
export async function getControlAccess(rcDeviceId) {
  const res = await apiFetch(
    `/api/services/cleaning/control-access/${encodeURIComponent(rcDeviceId)}`,
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "Failed to load control access");
  }
  return data;
}

export async function setControlAccess(rcDeviceId, userPkId, enabled) {
  const res = await apiFetch(
    `/api/services/cleaning/control-access/${encodeURIComponent(rcDeviceId)}`,
    { method: "PUT", body: JSON.stringify({ userPkId, enabled }) },
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "Failed to update control access");
  }
  return data;
}
